export default __webpack_public_path__ + "static/media/analytics.385d8b3b.svg";